import { Main_Close_Logo } from "../../assets/imgs";
import { Box, FormControlLabel, InputAdornment, Stack, Pagination, PaginationItem, FormControl, Dialog, SelectChangeEvent, Grid, Typography, MenuItem, Select } from '@mui/material';
import { useState, useContext, useEffect, useRef, ReactNode } from "react";
import { GridColDef, GridComparatorFn, GridSortDirection, GridSortModel, gridPageCountSelector, gridPageSelector, gridPaginationSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import React from "react";
import { GlobalStateContext } from '../../store/GlobalState';
import { useNavigate } from "react-router-dom";
import ReactLoading from 'react-loading';
import {
    OverlayBaseContainer,
    OverlayActiveStyle,
    OverlayContentContainer,
    OverlayContentHeading,
    OverlayContentListItem,
    OverlayCloseLogo,
    ListContainer,
    FourContainer,
    Heading,
    GreenButton,
    RFIDLink,
    StyledTextField,
    RedButton,
    PopUpHeading,
    Textarea,
    DateContainer,
    ReviseTestResultCloseLogo,
    OverlayEditContentContainer,
    TestResultContainer
} from "../../assets/style"
import { dateTimeToTimeStr2, formatDate, formatDateTime, formatTime, generateACurrentDateTimeInUTF8 } from "../../utils/dateTimeFormmater";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import { useLazyGetCubeInformationBySampleNumberQuery, useLazyGetCubeInformationQuery, useLazyGetRFIDQuery, useLazyGetTestResultQuery, useLazyGetReviseTestResultQuery, useLazyGetTestResultDateQuery, useSaveReviseTestResultMutation, useLazyCheckUserPermissionQuery } from "../../features/remainingWork/remainingWorkApiSlice";
import CountdownContainer from "../CountdownTimer/CountdownContainer";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useLazyGetRevisionRfidsQuery, usePostRevisionReasonMutation } from "../../features/remainingWork/reasonApiSlice";
import { useLazyGetUsersQuery } from "../../features/users/usersApiSlice";

const RemainingWorkContainer = ({ date, staffId, setRefreshTodoListCounter, refreshTodoListCounter }: { date: any, staffId: any, setRefreshTodoListCounter: any, refreshTodoListCounter: any }) => {
    var rowCount = 0;
    const [dimensionDatePickerValue, setDimensionDatePickerValue] = React.useState<Dayjs | string | null>(null);
    const [massDatePickerValue, setMassDatePickerValue] = React.useState<Dayjs | string | null>(null);
    const [datePickerValue, setDatePickerValue] = React.useState<Dayjs | string | null>(null);
    const [editTime, setEditTime] = React.useState<Dayjs>(dayjs());
    const [start, setStart] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingResult, setIsLoadingResult] = useState(false);
    const [tableContent, setTableContent] = useState<ReactNode>(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [getRFIDQuery, result] = useLazyGetRFIDQuery();
    const [getCubeInformation, cubeInformation] = useLazyGetCubeInformationQuery();
    const [getTestResult, testResult] = useLazyGetTestResultQuery();
    const [checkUserPermissionQuery, checkResult] = useLazyCheckUserPermissionQuery();
    const [getTestResultDate, testResultDate] = useLazyGetTestResultDateQuery();
    const [getReviseTestResult, reviseTest] = useLazyGetReviseTestResultQuery();
    const [getRevisionRfids, revisionRfids] = useLazyGetRevisionRfidsQuery();
    const [showCubeInformationOverlay, setShowCubeInformationOverlay] = useState(false);
    const [overlayCubeInformation, setOverlayCubeInformation] = React.useState<null | OverlayCubeInformationType>();

    const [showEditInformationOverlay, setShowEditInformationOverlay] = useState(false);
    // const [overlayEditInformation, setOverlayEditInformation] = React.useState<any>();

    const [startCountdown, setStartCountdown] = useState(true);
    const [secondsLeftOfCountdown, setSecondsLeftOfCountdown] = useState(60);
    const navigate = useNavigate();
    const globalState = useContext(GlobalStateContext);
    const [reviseTestResult, setReviseTestResult] = useState<any>(null);
    const [reviseTestResultDate, setReviseTestResultDate] = useState<any>(null);
    const [sortBy, setSortBy] = useState('');
    const [direction, setDirection] = useState('');
    const [squareness1, setSquareness1] = React.useState('P');
    const [squareness2, setSquareness2] = React.useState('P');
    const [saveReviseTestResult] = useSaveReviseTestResultMutation();
    const [loadAtFailure, setLoadAtFailure] = React.useState('');
    const [testMachine, setTestMachine] = React.useState('');
    const [width, setWidth] = React.useState('');
    const [height, setHeight] = React.useState('');
    const [length, setLength] = React.useState('');
    const [air, setAir] = React.useState('');
    const [water, setWater] = React.useState('');
    const [code, setCode] = React.useState('');
    // const [edit, setEdit] = React.useState(false);
    const [reasonCounter, setReasonCounter] = useState(0);
    // const [userPermission, setUserPermission] = React.useState(false);
    // const [isSaving, setIsSaving] = useState(false);

    type OverlayCubeInformationType = {
        "cbtCode": String,
        "sampleNumber": Number,
        "product": String,
        "productGrade": String,
        "cMixId": String,
        "cCubeGradeText": String,
        "supplier": String,
        "cPlantLocation": String,
        "cSamplingDate": String,
        "cDateCast": String,
        "dateTest": String,
        "cReceivedDate": String,
        "cubeMark": String,
        "name": String
    }

    type ReviseTestResult = {
        "uploadedBy": string,
        "date": String,
        "code": String,
        "sampleNumber": String,
        // "date": String,
        "width": String,
        "height": String,
        "length": String,
        "dimensionDate": Dayjs | String | null,
        "squareness1": String,
        "squareness2": String,
        "airMass": String,
        "waterMass": String,
        "massDate": Dayjs | String | null,
        "calculationDensity": String,
        "waterDensity": String,
        "loadAtFailure": String,
        "testMachine": String,
        "typeofFracture": String,
        "failureDate": Dayjs | String | null
    }

    type RevisionReasonCommonReasonsType = {
        "reasonBadTag": String | null,
        "reasonBadEquipment": String | null,
        "reasonCancelOrder": String | null,
        "reasonRecordOnly": String | null,
        "reasonToDo": String | null
    }

    useEffect(() => {
        setReviseTestResult(testResult.data);
        setReviseTestResultDate(testResultDate.data);
        setCode(reviseTestResult?.cbtCode)
        setWidth(reviseTestResult?.width)
        setHeight(reviseTestResult?.height)
        setLength(reviseTestResult?.length)
        setSquareness1(reviseTestResult?.squarenessS1 || 'P')
        setSquareness2(reviseTestResult?.squarenessS2 || 'P')
        setAir(reviseTestResult?.weightInAir)
        setWater(reviseTestResult?.weightInWater)
        setLoadAtFailure(reviseTestResult?.loadAtFailure)
        setTestMachine(reviseTestResult?.testMachine)
        setDatePickerValue(reviseTestResultDate?.eventDate7 || "")
        setMassDatePickerValue(reviseTestResultDate?.eventDate6 || "")
        setDimensionDatePickerValue(reviseTestResultDate?.eventDate5 || "")
    }, [testResult, testResultDate]);

    // const handleReviseTestResult = async (cbtCode: any) => {
    //     try {
    //         handleShowData()
    //         toggleEditOverlay()
    //         setIsLoadingResult(true);
    //         await getTestResult(cbtCode).then(
    //             (async (response: any) => {
    //                 if (response.isError) {
    //                     alert("Fetching test result error, please try again.")
    //                     toggleEditOverlay()
    //                 }
    //             }
    //             ));
    //         await getTestResultDate(cbtCode)
    //     } catch (error) {
    //         alert("Fetching test result error, please try again.")
    //     } finally {
    //         setIsLoadingResult(false)
    //     }
    // }
    const handleReviseTestResult = async (cbtCode: any) => {

        try {
            handleShowData()
            toggleEditOverlay()
            setIsLoadingResult(true);
            await getTestResult(cbtCode).then(
                (async (response: any) => {
                    if (response.isError) {
                        // alert("Fetching test result error, please try again.")
                        // setReasonCounter(reasonCounter + 1)
                        toggleEditOverlay()
                    }
                }
                ));
            await getTestResultDate(cbtCode).then(
                (async (response: any) => {
                    if (response.isError) {
                        toggleEditOverlay()
                    }
                }
                ));
        } catch (error) {
            alert("Fetching test result error, please try again.")
            // setReasonCounter(reasonCounter + 1)
        } finally {
            setIsLoadingResult(false)
        }
    }

    useEffect(() => {
        handleTableData(date.toISOString());
    }, [reasonCounter, date, searchQuery]);

    const toggleOverlay = () => {
        const opposite = !showCubeInformationOverlay
        setShowCubeInformationOverlay(opposite)
    }

    const toggleEditOverlay = () => {
        const opposite = !showEditInformationOverlay
        setShowEditInformationOverlay(opposite)
        // setReasonCounter(reasonCounter + 1)
    }

    // const toggleReviseTestResult = () => {
    //     // setEdit(false)
    //     handleShowData()
    // }
    const handleCubeInformation = async (rfid: any) => {
        await getCubeInformation(rfid);
        toggleOverlay()
    }

    const handleShowData = async () => {
        setCode('')
        setWidth('');
        setHeight('');
        setLength('');
        setAir('');
        setWater('');
        setSquareness1('P')
        setSquareness2('P')
        setLoadAtFailure('')
        setTestMachine('')
        setDatePickerValue('')
        setDimensionDatePickerValue('')
        setMassDatePickerValue('')
    }


    const handleSaveButton = async (e: any) => {
        e.preventDefault()
        console.log(reviseTestResult)
        if (reviseTestResult?.cbtCode) {
            // -------------------------------------------------for later implement checking-------------------------------------------------
            // if (!((width || height || length || reviseTestResult?.width || reviseTestResult?.height || reviseTestResult?.length)
            //     && (dimensionDatePickerValue || reviseTestResultDate?.eventDate5))) {
            //     alert("Please complete all parts before submit.")
            //     console.log('dimensionDatePickerValue: ' + width + " , " + height + " , " + length
            //         + " , " + dimensionDatePickerValue + " , " + reviseTestResultDate?.eventDate5 + " , ")
            //     return;
            // } if (!((air || water || reviseTestResult?.weightInAir || reviseTestResult?.weightInWater)
            //     && (massDatePickerValue || reviseTestResultDate?.eventDate6))) {
            //     alert("Please complete all parts before submit.")
            //     console.log('massDatePickerValue: ' + air + " , " + water + " , " + reviseTestResult?.weightInAir + " , " + reviseTestResult?.weightInWater
            //         + " , " + massDatePickerValue + " , " + reviseTestResultDate?.eventDate6 + " , ")
            //     return;
            // }
            // if (!((loadAtFailure)
            //     && (datePickerValue || reviseTestResultDate?.eventDate7))) {
            //     alert("Please complete all parts before submit.")
            //     console.log('datePickerValue')
            //     return;
            // }
            // -------------------------------------------------for later implement checking-------------------------------------------------
            setIsLoadingResult(true);
            setEditTime(dayjs(new Date()))
            try {
                const reviseTestResultList: ReviseTestResult = {
                    uploadedBy: staffId ? staffId : "",
                    date: editTime.toISOString(),
                    code: reviseTestResult?.cbtCode,
                    sampleNumber: reviseTestResult?.sampleNumber ? reviseTestResult?.sampleNumber.toString() : "",
                    width: width ? width : "",
                    height: height ? height : "",
                    length: length ? length : "",
                    dimensionDate: dimensionDatePickerValue ? dimensionDatePickerValue : "",
                    squareness1: squareness1 ? squareness1 : "",
                    squareness2: squareness2 ? squareness2 : "",
                    airMass: air ? air : "",
                    waterMass: water ? water : "",
                    massDate: massDatePickerValue ? massDatePickerValue : "",
                    calculationDensity: ((air) && (height) && (width) && (length))
                        ? (Number(air) * 1000000000 / (Number(height) * Number(width) * Number(length))).toFixed(1)
                        : '',
                    waterDensity: ((air) && (water))
                        ? (Number(air) * 997 / (Number(air) - Number(water))).toFixed(1)
                        : '',
                    loadAtFailure: loadAtFailure ? loadAtFailure : "",
                    testMachine: testMachine ? testMachine : "",
                    typeofFracture: reviseTestResult?.typeOfFailOfSample ? reviseTestResult?.typeOfFailOfSample : "",
                    failureDate: datePickerValue ? datePickerValue : "",
                };
                await saveReviseTestResult(reviseTestResultList);
            } catch (error) {
                console.error('Error fetching test result:', error);
            } finally {
                setIsLoadingResult(false)
                alert('The result has been edited.')
                setShowEditInformationOverlay(!showEditInformationOverlay)
                handleShowData()
                // setEdit(false)
                setRefreshTodoListCounter(refreshTodoListCounter + 1)
                setReasonCounter(reasonCounter + 1)
            }
        }
        else if (reviseTestResult?.code) {
            setIsLoadingResult(true);
            setEditTime(dayjs(new Date()))
            try {
                // const reviseTestResultList: ReviseTestResult = {
                //     uploadedBy: staffId ? staffId : "",
                //     date: editTime.toISOString(),
                //     code: reviseTestResult?.code,
                //     sampleNumber: reviseTestResult?.sampleNumber ? reviseTestResult?.sampleNumber.toString() : "",
                //     width: reviseTestResult?.width ? reviseTestResult?.width : width ? width : "",
                //     height: reviseTestResult?.height ? reviseTestResult?.height : height ? height : "",
                //     length: reviseTestResult?.length ? reviseTestResult?.length : length ? length : "",
                //     dimensionDate: dimensionDatePickerValue || "",
                //     squareness1: squareness1 ? squareness1 : reviseTestResult?.squareness1 ? reviseTestResult?.squareness1 : "",
                //     squareness2: squareness2 ? squareness2 : reviseTestResult?.squareness2 ? reviseTestResult?.squareness2 : "",
                //     airMass: reviseTestResult?.airMass ? reviseTestResult?.airMass : air ? air : "",
                //     waterMass: reviseTestResult?.waterMass ? reviseTestResult?.waterMass : water ? water : "",
                //     massDate: massDatePickerValue || "",
                //     calculationDensity: ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) && (reviseTestResult?.height || height) && (reviseTestResult?.width || width) && (reviseTestResult?.length || length))
                //         ? (Number(reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) * 1000000000 / Number(((reviseTestResult?.height || height) * (reviseTestResult?.width || width) * (reviseTestResult?.length || length)))).toFixed(1)
                //         : ''
                //     ,
                //     waterDensity: ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) && (reviseTestResult?.weightInWater || reviseTestResult?.waterMass || water))
                //         ? ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) * 997 / ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) - (reviseTestResult?.weightInWater || reviseTestResult?.waterMass || water))).toFixed(1)
                //         : '',
                //     loadAtFailure: reviseTestResult?.loadAtFailure ? reviseTestResult?.loadAtFailure : loadAtFailure ? loadAtFailure : "",
                //     typeofFracture: reviseTestResult?.typeofFracture ? reviseTestResult?.typeofFracture : "",
                //     failureDate: datePickerValue || "",
                // };
                const reviseTestResultList: ReviseTestResult = {
                    uploadedBy: staffId ? staffId : "",
                    date: editTime.toISOString(),
                    code: reviseTestResult?.code,
                    sampleNumber: reviseTestResult?.sampleNumber ? reviseTestResult?.sampleNumber.toString() : "",
                    width: width ? width : "",
                    height: height ? height : "",
                    length: length ? length : "",
                    dimensionDate: dimensionDatePickerValue ? dimensionDatePickerValue : "",
                    squareness1: squareness1 ? squareness1 : "",
                    squareness2: squareness2 ? squareness2 : "",
                    airMass: air ? air : "",
                    waterMass: water ? water : "",
                    massDate: massDatePickerValue ? massDatePickerValue : "",
                    calculationDensity: ((air) && (height) && (width) && (length))
                        ? (Number(air) * 1000000000 / (Number(height) * Number(width) * Number(length))).toFixed(1)
                        : '',
                    waterDensity: ((air) && (water))
                        ? (Number(air) * 997 / (Number(air) - Number(water))).toFixed(1)
                        : '',
                    loadAtFailure: loadAtFailure ? loadAtFailure : "",
                    testMachine: testMachine ? testMachine : "",
                    typeofFracture: reviseTestResult?.typeOfFailOfSample ? reviseTestResult?.typeOfFailOfSample : "",
                    failureDate: datePickerValue ? datePickerValue : "",
                };
                await saveReviseTestResult(reviseTestResultList);
            } catch (error) {
                console.error('Error fetching test result:', error);
            } finally {
                setIsLoadingResult(false)
                alert('The result has been edited.')
                // setEdit(false)

                setShowEditInformationOverlay(!showEditInformationOverlay)
                setRefreshTodoListCounter(refreshTodoListCounter + 1)
                setReasonCounter(reasonCounter + 1)

            }
        } else if (reviseTestResult?.sampleNumber) {
            setIsLoadingResult(true);
            setEditTime(dayjs(new Date()))
            try {
                const reviseTestResultList: ReviseTestResult = {
                    uploadedBy: staffId ? staffId : "",
                    date: editTime.toISOString(),
                    code: `**${reviseTestResult?.sampleNumber}**`,
                    sampleNumber: reviseTestResult?.sampleNumber.toString(),
                    width: width ? width : "",
                    height: height ? height : "",
                    length: length ? length : "",
                    dimensionDate: dimensionDatePickerValue ? dimensionDatePickerValue : "",
                    squareness1: squareness1 ? squareness1 : "",
                    squareness2: squareness2 ? squareness2 : "",
                    airMass: air ? air : "",
                    waterMass: water ? water : "",
                    massDate: massDatePickerValue ? massDatePickerValue : "",
                    calculationDensity: ((air) && (height) && (width) && (length))
                        ? (Number(air) * 1000000000 / (Number(height) * Number(width) * Number(length))).toFixed(1)
                        : '',
                    waterDensity: ((air) && (water))
                        ? (Number(air) * 997 / (Number(air) - Number(water))).toFixed(1)
                        : '',
                    loadAtFailure: loadAtFailure ? loadAtFailure : "",
                    testMachine: testMachine ? testMachine : "",
                    typeofFracture: reviseTestResult?.typeOfFailOfSample ? reviseTestResult?.typeOfFailOfSample : "",
                    failureDate: datePickerValue ? datePickerValue : "",
                };
                await saveReviseTestResult(reviseTestResultList);
            } catch (error) {
                console.error('Error fetching test result:', error);
            } finally {
                setIsLoadingResult(false)
                alert('The result has been edited.')
                // setEdit(false)
                setShowEditInformationOverlay(!showEditInformationOverlay)
                setRefreshTodoListCounter(refreshTodoListCounter + 1)
                setReasonCounter(reasonCounter + 1)
            }

        }
        else {
            alert("Please select a work before save.")
        }
    }


    const handleTestResult = async (cbtCode: any, sampleNumber: any) => {//here
        try {
            getReviseTestResult(cbtCode ? cbtCode : sampleNumber)
                .then(async (response: any) => {
                    if (response.isError) {
                        // // alert("No edit record.");
                        // checkUserPermissionQuery(staffId).then(async res => {
                        //     if (res.data) {
                        await handleReviseTestResult(cbtCode)

                        //     } else {
                        //         alert("You don't have permission to edit record.");
                        //     }
                        // });
                    } else {
                        // alert("There is already an edit record.");
                        handleTestResultDataByXmlFile(response.data);

                    }
                });
        } catch (error) {
            alert("An error occur, please refresh the website and try again.")
        }

    }

    const handleTestResultDataByXmlFile = async (xml: any) => {
        try {
            console.log('call handleTestResultDataByXmlFile')
            handleShowData()
            // setUserPermission(true)
            // setEdit(true);
            setIsLoadingResult(true);

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xml, "text/xml");

            setCode(xmlDoc.getElementsByTagName("CBT_CODE")[0].textContent! || xmlDoc.getElementsByTagName("SAMPLE_NUMBER")[0].textContent!)
            setWidth(xmlDoc.getElementsByTagName("WIDTH")[0].textContent!)
            setHeight(xmlDoc.getElementsByTagName("HEIGHT")[0].textContent!)
            setLength(xmlDoc.getElementsByTagName("LENGTH")[0].textContent!)
            setDimensionDatePickerValue((xmlDoc.getElementsByTagName("DIMENSION_DATE")[0].textContent))
            setSquareness1(xmlDoc.getElementsByTagName("SQUARENESS_S1")[0].textContent!)
            setSquareness2(xmlDoc.getElementsByTagName("SQUARENESS_S2")[0].textContent!)
            setAir(xmlDoc.getElementsByTagName("AIR_MASS")[0].textContent!)
            setWater(xmlDoc.getElementsByTagName("WATER_MASS")[0].textContent!)
            setMassDatePickerValue((xmlDoc.getElementsByTagName("MASS_DATE")[0].textContent!))
            setLoadAtFailure(xmlDoc.getElementsByTagName("LOAD_AT_FAILURE")[0].textContent!)
            // setTestMachine(xmlDoc.getElementsByTagName("TEST_MACHINE")[0]?.textContent!)

            const testMachineTag = xmlDoc.getElementsByTagName("TEST_MACHINE")[0];
            const testMachineContent = testMachineTag ? testMachineTag.textContent : "";
            if (testMachineContent) {
                setTestMachine(testMachineContent);
            } else {
                setTestMachine("");
            }
            console.log("setTestMachine in xml function: " + testMachine)
            setDatePickerValue((xmlDoc.getElementsByTagName("CS_DATE")[0].textContent!))
            const reviseTestResultByxml: ReviseTestResult = {
                uploadedBy: staffId,
                date: editTime.toISOString(),
                code: xmlDoc.getElementsByTagName("CBT_CODE")[0].textContent! || xmlDoc.getElementsByTagName("SAMPLE_NUMBER")[0].textContent!,
                sampleNumber: xmlDoc.getElementsByTagName("SAMPLE_NUMBER")[0].textContent!,
                width: xmlDoc.getElementsByTagName("WIDTH")[0].textContent!,
                height: xmlDoc.getElementsByTagName("HEIGHT")[0].textContent!,
                length: xmlDoc.getElementsByTagName("LENGTH")[0].textContent!,
                dimensionDate: xmlDoc.getElementsByTagName("DIMENSION_DATE")[0].textContent,
                squareness1: xmlDoc.getElementsByTagName("SQUARENESS_S1")[0].textContent!,
                squareness2: xmlDoc.getElementsByTagName("SQUARENESS_S2")[0].textContent!,
                airMass: xmlDoc.getElementsByTagName("AIR_MASS")[0].textContent!,
                waterMass: xmlDoc.getElementsByTagName("WATER_MASS")[0].textContent!,
                massDate: xmlDoc.getElementsByTagName("MASS_DATE")[0].textContent,
                calculationDensity: ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) && (reviseTestResult?.height || height) && (reviseTestResult?.width || width) && (reviseTestResult?.length || length))
                    ? (Number(reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) * 1000000000 / Number(((reviseTestResult?.height || height) * (reviseTestResult?.width || width) * (reviseTestResult?.length || length)))).toFixed(1)
                    : ''
                ,
                waterDensity: ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) && (reviseTestResult?.weightInWater || reviseTestResult?.waterMass || water))
                    ? ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) * 997 / ((reviseTestResult?.weightInAir || reviseTestResult?.airMass || air) - (reviseTestResult?.weightInWater || reviseTestResult?.waterMass || water))).toFixed(1)
                    : '',
                loadAtFailure: xmlDoc.getElementsByTagName("LOAD_AT_FAILURE")[0].textContent!,
                testMachine: testMachineContent ? testMachineContent : "",
                typeofFracture: reviseTestResult?.typeOfFailOfSample ? reviseTestResult?.typeOfFailOfSample : "",
                failureDate: xmlDoc.getElementsByTagName("CS_DATE")[0].textContent!,
            }

            setReviseTestResult(reviseTestResultByxml);
            setReviseTestResultDate(reviseTestResultByxml);
            toggleEditOverlay()
        } catch (error) {
            console.error('Error fetching test result:', error);
        } finally {
            setIsLoadingResult(false)
            // setReasonCounter(reasonCounter + 1);
        }
    }

    useEffect(() => {
        if (cubeInformation.isSuccess) {
            const cubeInfo = cubeInformation.data;
            setOverlayCubeInformation(cubeInfo as OverlayCubeInformationType)
        }
    }, [cubeInformation])

    // useEffect(() => {
    //     if (testResult.isSuccess || testResultDate.isSuccess) {
    //         var testInfo = testResult.data || null;
    //         var testDateInfo = testResultDate.data || null;
    //         // if (testInfo)
    //         //     testInfo = testInfo.(testDateInfo);
    //         setOverlayEditInformation({ testInfo, testDateInfo })
    //     }
    // }, [testResult, testResultDate])

    const handleTableData = async (date: any) => {
        setIsLoading(true)
        try {
            if (globalState.token) {
                // await getRevisionRfids(date).unwrap()
                // await getRFIDQuery({ date: date, sortBy: sortBy, direction: direction }).unwrap();
                getRFIDQuery({ date: date, sortBy: sortBy, direction: direction }).then((data) => {
                    if (data.error) {
                        navigate('/main')
                    }
                    setIsLoading(false); // Set isLoading to false when loading or updating is completed or when an error occurs
                });
                getRevisionRfids(date).then((data) => {
                    if (data.error) {
                        navigate('/main')
                    }
                    // setIsLoading(false);
                });
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            localStorage.setItem('token', '');
            globalState.setToken('');
            navigate("/");
        } finally {
            setStartCountdown(false); // close the zero-second timer
            setStart(true);
        }
    }

    useEffect(() => {
        if (start) {
            const secondsOfCountdown = 60;

            if (secondsLeftOfCountdown === 0) {
                handleTableData(date.toISOString());
                setSecondsLeftOfCountdown(secondsOfCountdown);
            }

            setStartCountdown(true);

            const timeoutID = setTimeout(() => {
                if (secondsLeftOfCountdown > 0) {
                    setSecondsLeftOfCountdown(secondsLeftOfCountdown - 1);
                }
            }, 1000);

            return () => {
                clearTimeout(timeoutID);
            };
        }
    }, [result.data, startCountdown, start, secondsLeftOfCountdown]);

    useEffect(() => {
        if (result.isSuccess && revisionRfids.isSuccess) {
            const responseData = result.data;
            const header: GridColDef[] = [
                {
                    field: 'rfid',
                    headerName: 'RFID / QR / Sample Number',
                    width: 300,
                    renderCell: (params) => {
                        const handleRfidClick = async () => {
                            handleCubeInformation(params.value);
                        };
                        return (
                            (<RFIDLink onClick={(e) => { handleRfidClick() }}>
                                {params.value}
                            </RFIDLink >)
                        );
                    },
                },
                // { field: 'LRNName', headerName: 'LRN Name', width: 200 },
                { field: 'companyName', headerName: 'Company', width: 300 },
                { field: 'cubeMark', headerName: 'Cube Mark', width: 300 },
                { field: 'testDate', headerName: 'Limit of Test Date 預定測試日', width: 300 },
                { field: 'testTime', headerName: 'Limit Of Test Time 預定測試時間', width: 300 },
                { field: 'reason', headerName: 'Reason 原因', width: 150, sortable: false, renderCell: (params) => params.value },
                { field: 'detail', headerName: 'Detail 詳細', width: 150, sortable: false, renderCell: (params) => params.value },
            ];

            const filteredData = (responseData as any[]).filter((record: any) => {
                var query = (record.cbtCode != null)
                    ? record?.cbtCode?.includes(searchQuery)
                    : record?.sampleNumber?.toString().includes(searchQuery)
                if (!query)
                    query = record?.cubeMark?.includes(searchQuery)
                return query;
            });
            const row = filteredData.map((record: any, index: number) => {
                const isSelected = revisionRfids.data.includes(record.cbtCode ?? `**${record.sampleNumber}**`);
                return {
                    id: index + 1 + '.',
                    rfid:
                        (record.cbtCode != null)
                            ?
                            record.cbtCode
                            :
                            `**${record.sampleNumber}**`
                    ,
                    // LRNName: record.name,
                    companyName: record.companyName,
                    cubeMark: record.cubeMark,
                    testDate: formatDate(record.dateTest),
                    testTime: formatTime(record.lowerLimitOfTestDate) + " ~ " + formatTime(record.upperLimitOfTestDate),
                    reason: (
                        <>
                            <ReasonButton id={index}
                                rfid={record.cbtCode ?? `**${record.sampleNumber}**`}
                                dateTest={record.dateTest}
                                customer={record.customer} />
                        </>

                    ),
                    detail: (
                        <GreenButton
                            variant="contained"
                            disabled={!isSelected}
                            onClick={(e) => {
                                checkUserPermissionQuery(staffId).then(async res => {
                                    if (res.data) {
                                        (record.cbtCode != null)
                                            ? handleTestResult(record.cbtCode, record.sampleNumber)
                                            : (record.code != null)
                                                ? handleTestResult(record.code, record.sampleNumber)
                                                : handleTestResult(record.sampleNumber, record.sampleNumber)

                                    } else {
                                        alert("You don't have permission to edit record.");
                                    }
                                });

                            }}
                        >
                            Edit
                        </GreenButton>
                    ),
                };
            });

            rowCount = row.length;

            const sortModel = sortBy && direction ? [{ field: sortBy, sort: direction as GridSortDirection }] : [];

            setTableContent(
                <>
                    <DataGrid
                        sx={{
                            '&>.MuiDataGrid-main': {
                                '&>.MuiDataGrid-columnHeaders': {
                                    borderBottomColor: '#F09B9B',
                                },

                                '& div div div div >.MuiDataGrid-cell': {
                                    borderBottom: 'none',
                                    borderBottomColor: 'transparent'
                                },
                            },
                            '&>.MuiDataGrid-footerContainer': {

                                borderTopColor: '#F09B9B',
                            },
                            borderColor: 'transparent',
                        }}
                        rowHeight={32}
                        columnHeaderHeight={25}
                        rows={row}
                        columns={header}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 7 },
                            },
                        }}
                        slots={{
                            pagination: CustomPagination,
                        }}
                        //pageSizeOptions={[5, 10]}
                        disableColumnMenu
                        // resizeColumns
                        autoHeight
                        sortModel={sortModel}
                        onSortModelChange={(model) => {
                            if (model.length > 0) {
                                const { field, sort } = model[0];
                                setSortBy(field);
                                setDirection(sort as string);
                            } else {
                                setSortBy('');
                                setDirection('');
                            }
                        }}
                    />
                </>
            );
        }
    }, [result, searchQuery, sortBy, direction, start, reasonCounter]);

    const CustomPagination = () => {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
        const paginationState = useGridSelector(apiRef, gridPaginationSelector);
        return (
            <>
                <Stack direction="row" spacing={2}>
                    {
                        rowCount != 0 &&
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {paginationState.paginationModel.pageSize * page + 1} - {" "}
                            {(paginationState.paginationModel.pageSize * page + paginationState.paginationModel.pageSize) > rowCount ?
                                (rowCount + " of ")
                                : (paginationState.paginationModel.pageSize * page + paginationState.paginationModel.pageSize + " of ")}{rowCount}
                        </Box>
                    }
                    <Pagination
                        color="primary"
                        count={pageCount}
                        page={page + 1}
                        onChange={(event, value) => apiRef.current.setPage(value - 1)}
                        variant="outlined"
                        shape="rounded"
                        sx={{
                            button: { borderColor: "#F09B9B" },
                        }}
                        renderItem={(item) => (
                            <PaginationItem
                                // components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                {...item}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "#F09B9B",
                                        color: "white",
                                        borderColor: "transparent",
                                        fontSize: 16,
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "8px"
                                    }
                                }}
                            />
                        )}
                    />
                </Stack>
            </>
        );
    }

    const ReasonButton = (
        { id, rfid, dateTest, customer }
            : { id: number, rfid: string, dateTest: string, customer: string }
    ) => {
        const [open, setOpen] = useState(false);
        return (
            <>
                <GreenButton
                    variant="contained"
                    // disabled = {isSelected}
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    Select
                </GreenButton>

                <Reason
                    id={id}
                    rfid={rfid}
                    dateTest={dateTest}
                    customer={customer}
                    open={open}
                    onClose={() => {
                        setOpen(false);
                    }}
                />
            </>
        );
    };

    const Reason = ({
        id,
        rfid,
        dateTest,
        customer,
        open,
        onClose,
    }: {
        id: number;
        rfid: string;
        dateTest: string,
        customer: string,
        open: boolean;
        onClose: Function;
    }) => {
        const [inputOtherReason, setInputOtherReason] = React.useState(false);
        const [loading, setLoading] = React.useState(false);
        const [revisionReasonCommonReasons, setRevisionReasonCommonReasons] = useState<RevisionReasonCommonReasonsType | null>(null); // This will be a object to be sent with POST request
        const [revisionReasonOtherReason, setRevisionReasonOtherReason] = useState<string | null>(null) // This will be a object to be sent with POST request
        const [postRevisionReason] = usePostRevisionReasonMutation()
        const [getUsersQuery, { data: users, error, isLoading, }] = useLazyGetUsersQuery();
        const handelReasonButton = async () => {


            setLoading(true);
            try {
                const hrProStaff = await getUsersQuery().unwrap();
                const body = {
                    username: `${hrProStaff?.surName} ${hrProStaff?.otherName}`,
                    staffId: hrProStaff?.eeNo,
                    dateTest: dateTest,
                    customer: customer,
                    cbtCodeOrSampleNumber: rfid,
                    ...revisionReasonCommonReasons,
                    reasonOther: revisionReasonOtherReason,
                    creationDateTime: generateACurrentDateTimeInUTF8().toISOString()

                }
                const revisionReason = await postRevisionReason(body).unwrap()
            } catch (error) {
                alert('There was a problem uploading the reason, please try again.')
            }
            finally {
                alert('Reason uploaded.')
                setLoading(false)
                setReasonCounter(reasonCounter + 1)
                setRefreshTodoListCounter(Math.random())
            }
            onClose();
        }
        return (
            <>
                <Dialog
                    open={open}
                    onClose={() => {
                        onClose();
                    }}
                    fullWidth={true}
                    PaperProps={{
                        style: { borderRadius: "30px" },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "18px",
                        }}
                    >
                        <Box
                            sx={{
                                padding: "15px",
                                backgroundColor: "white",
                                borderRadius: "30px",
                            }}
                        >
                            <PopUpHeading>Reason 原因 : {rfid}</PopUpHeading>
                            <hr style={{ borderTop: '1px solid #F09B9B' }} />
                            {loading && <ReactLoading className="justify-items-center" type={"bubbles"} color={'#000000'} height={'20%'} width={'20%'} />}
                            {
                                !loading
                                && <ControlledRadioButtonsGroup
                                    setInputOtherReason={setInputOtherReason}
                                    setRevisionReasonCommonReasons={setRevisionReasonCommonReasons}
                                    setRevisionReasonOtherReason={setRevisionReasonOtherReason}
                                />
                            }
                            <div style={{ marginTop: '20px' }}>
                                <GreenButton
                                    variant="contained"
                                    onClick={async () => {
                                        handelReasonButton()
                                    }}
                                    disabled={!inputOtherReason}
                                >
                                    Save
                                </GreenButton>
                                <RedButton
                                    style={{
                                        marginLeft: '20px'
                                    }}
                                    variant="contained"
                                    onClick={() => {
                                        onClose();
                                    }}
                                >
                                    Cancel
                                </RedButton>
                            </div>
                        </Box>
                    </Box>
                </Dialog>
            </>
        );
    };

    function ControlledRadioButtonsGroup({ setInputOtherReason, setRevisionReasonCommonReasons, setRevisionReasonOtherReason }: { setInputOtherReason: React.Dispatch<React.SetStateAction<boolean>>, setRevisionReasonCommonReasons: React.Dispatch<React.SetStateAction<RevisionReasonCommonReasonsType | null>>, setRevisionReasonOtherReason: React.Dispatch<React.SetStateAction<string | null>> }) {
        const [value, setValue] = React.useState('tag');
        const [otherValue, setOtherValue] = React.useState('');

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            setValue(event.target.value);
        };

        const handleTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
            const inputValue = event.target.value;
            setOtherValue(inputValue);
        };

        React.useEffect(() => {
            if (value === 'other') {
                setInputOtherReason(otherValue.trim() !== '');

                // prepare POST request's payload, which nullify all common reason and provide other reason
                setRevisionReasonCommonReasons(null)
                setRevisionReasonOtherReason(otherValue.trim())
            } else {
                setInputOtherReason(true);
                setOtherValue('');

                // prepare POST request's payload, which provide one common reason and not provide other reason
                setRevisionReasonOtherReason(null)
                switch (value) {
                    case "tag":
                        setRevisionReasonCommonReasons({
                            "reasonBadTag": "YES",
                            "reasonBadEquipment": null,
                            "reasonCancelOrder": null,
                            "reasonRecordOnly": null,
                            "reasonToDo": null
                        })
                        break
                    case "equipment":
                        setRevisionReasonCommonReasons({
                            "reasonBadTag": null,
                            "reasonBadEquipment": "YES",
                            "reasonCancelOrder": null,
                            "reasonRecordOnly": null,
                            "reasonToDo": null
                        })
                        break
                    case "cancel":
                        setRevisionReasonCommonReasons({
                            "reasonBadTag": null,
                            "reasonBadEquipment": null,
                            "reasonCancelOrder": "YES",
                            "reasonRecordOnly": null,
                            "reasonToDo": null
                        })
                        break
                    case "record":
                        setRevisionReasonCommonReasons({
                            "reasonBadTag": null,
                            "reasonBadEquipment": null,
                            "reasonCancelOrder": null,
                            "reasonRecordOnly": "YES",
                            "reasonToDo": null
                        })
                        break
                    case "toDo":
                        setRevisionReasonCommonReasons({
                            "reasonBadTag": null,
                            "reasonBadEquipment": null,
                            "reasonCancelOrder": null,
                            "reasonRecordOnly": null,
                            "reasonToDo": "YES"
                        })
                        break
                    default:
                        setRevisionReasonCommonReasons({
                            "reasonBadTag": null,
                            "reasonBadEquipment": null,
                            "reasonCancelOrder": null,
                            "reasonRecordOnly": null,
                            "reasonToDo": null
                        })
                }
            }
        }, [value, otherValue, setInputOtherReason]);

        return (
            <FormControl>
                <FormLabel id="reason-radio-buttons-group">Select a reason</FormLabel>
                <RadioGroup
                    aria-labelledby="reason-radio-buttons-group"
                    name="reason-radio-buttons-group"
                    value={value}
                    onChange={handleChange}
                >
                    <FormControlLabel value='tag' control={<Radio />} label="壞Tag" />
                    <FormControlLabel value='equipment' control={<Radio />} label="Equipment 設備有問題" />
                    <FormControlLabel value='cancel' control={<Radio />} label="Cancel order 取消" />
                    <FormControlLabel value='record' control={<Radio />} label="Record only 僅記錄" />
                    {/* <FormControlLabel value='toDo' control={<Radio />} label="To Do 待處理" /> */}
                    <div>
                        <FormControlLabel value="other" control={<Radio />} label="Other 其他原因: " />
                        <Textarea
                            aria-label="minimum height"
                            minRows={3}
                            style={{
                                resize: 'vertical',
                                borderColor: 'initial',
                                outline: 'none',
                                verticalAlign: 'top',
                                marginTop: '10px'
                            }}
                            onChange={handleTextAreaChange}
                            onClick={() => setValue("other")}
                            value={otherValue}
                        />
                    </div>
                </RadioGroup>
            </FormControl>
        );
    }

    function ReviseTestResult() {
        // const date = new Date(dateStr);
        return (
            <TestResultContainer flexGrow={1}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Heading style={{ marginRight: '20px' }}>Revise Test Result 更改測試結果</Heading>
                    <ReviseTestResultCloseLogo onClick={toggleEditOverlay}><img src={Main_Close_Logo} alt="close" style={{ width: 'calc(17px + 0.4vw)' }} /> </ReviseTestResultCloseLogo>
                </div>

                <ListContainer className="form-overide-styles">
                    <Box sx={{ flexGrow: 1 }}>
                        {isLoadingResult && <Grid container style={{ background: '#DCFFD74D', border: '1px solid #95D330', borderRadius: 20 }}><ReactLoading className="justify-items-center" type={"bubbles"} color={'#95D330'} height={'20%'} width={'20%'} /></Grid>}
                        {
                            !isLoadingResult
                            &&
                            <form onSubmit={handleSaveButton}>
                                <Grid container style={{ background: '#DCFFD74D', border: '1px solid #95D330', borderRadius: 20 }}>
                                    <Grid container>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={1} sm={1}></Grid>
                                        <Grid item xs={5} sm={5}>
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                RFID/QR: {code ? code
                                                    : reviseTestResult?.code ? reviseTestResult?.code
                                                        : reviseTestResult?.cbtCode ? reviseTestResult?.cbtCode
                                                            : reviseTestResult?.sampleNumber ? reviseTestResult?.sampleNumber
                                                                : ""}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <Typography variant="subtitle1" fontWeight="bold">Date / Time: {new Date().toLocaleString()}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} height={15}>
                                        <hr style={{ borderTop: '1px solid #95D330' }} />
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={1} sm={1}></Grid>
                                        <Grid item xs={2} sm={2}>
                                            <Typography variant="subtitle1" >Dimensions: </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <Typography variant="subtitle1" >W1-Width (mm): </Typography>
                                            <Typography variant="subtitle1" >W2-Height (mm): </Typography>
                                            <Typography variant="subtitle1" >W3-Length (mm): </Typography>
                                            <Typography style={{ height: '60px' }} variant="subtitle1" >Dimension date & time: </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <div>
                                                <input
                                                    id="width"
                                                    value={width}
                                                    onChange={(e) => setWidth(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                />
                                            </div>
                                            <div>
                                                <input id="height"
                                                    value={height}
                                                    onChange={(e) => setHeight(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                />
                                            </div>
                                            <div>
                                                <input id="length"
                                                    value={length}
                                                    onChange={(e) => setLength(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                />
                                            </div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} >
                                                <DateTimePicker
                                                    value={dayjs(dimensionDatePickerValue)}
                                                    onChange={(newValue) => setDimensionDatePickerValue(newValue ? newValue : null)}
                                                    disableFuture
                                                    timeSteps={{ hours: 1, minutes: 1 }}
                                                    format="DD MMM YYYY hh:mm A"
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} height={20}>
                                        <hr style={{ borderTop: '1px solid #95D330' }} />
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={1} sm={1}></Grid>
                                        <Grid item xs={2} sm={2}>
                                            <Typography variant="subtitle1">Squareness 1:</Typography>

                                            <Typography variant="subtitle1">Squareness 2:</Typography>
                                        </Grid>
                                        <Grid item xs={3} sm={3}>
                                            <FormControl fullWidth>
                                                <Select
                                                    id="squareness1"
                                                    value={squareness1}
                                                    onChange={(e) => setSquareness1(e.target.value)}
                                                    style={{ height: 35, backgroundColor: '#fff' }}
                                                >
                                                    <MenuItem value={"P"}>P</MenuItem>
                                                    <MenuItem value={"0.5"}>0.5</MenuItem>
                                                    <MenuItem value={"1"}>1</MenuItem>
                                                    <MenuItem value={"1.5"}>1.5</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <FormControl fullWidth>
                                                <Select
                                                    id="squareness2"
                                                    value={squareness2}
                                                    onChange={(e) => setSquareness2(e.target.value)}
                                                    style={{ height: 35, backgroundColor: '#fff' }}
                                                >
                                                    <MenuItem value={"P"}>P</MenuItem>
                                                    <MenuItem value={"0.5"}>0.5</MenuItem>
                                                    <MenuItem value={"1"}>1</MenuItem>
                                                    <MenuItem value={"1.5"}>1.5</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={1} sm={1}></Grid>
                                    </Grid>

                                    <Grid item xs={12} height={12}>
                                        <hr style={{ borderTop: '1px solid #95D330' }} />
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={1} sm={1}></Grid>
                                        <Grid item xs={2} sm={2}>
                                            <Typography variant="subtitle1" >Mass: </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <Typography variant="subtitle1" >Air: </Typography>
                                            <Typography variant="subtitle1" >Water: </Typography>
                                            <Typography variant="subtitle1" >Mass date & time: </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <div>
                                                <input id="air"
                                                    value={air}
                                                    onChange={(e) => setAir(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                />
                                            </div>
                                            <div>
                                                <input id="water"
                                                    value={water}
                                                    onChange={(e) => setWater(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                />
                                            </div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} >
                                                <DateTimePicker
                                                    value={dayjs(massDatePickerValue)}
                                                    onChange={(newValue) => setMassDatePickerValue(newValue ? newValue : null)}
                                                    disableFuture
                                                    timeSteps={{ hours: 1, minutes: 1 }}
                                                    format="DD MMM YYYY hh:mm A"
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} height={12}>
                                        <hr style={{ borderTop: '1px solid #95D330' }} />
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={1} sm={1}></Grid>
                                        <Grid item xs={2} sm={2}>
                                            <Typography variant="subtitle1" >Density: </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <Typography variant="subtitle1" >by Calculation(kg/m3): </Typography>
                                            <Typography variant="subtitle1" >by water-displacement(kg/m3): </Typography>
                                        </Grid>
                                        <Grid item xs={2} sm={2}>
                                            <Typography variant="subtitle1" >
                                                {((air) && (height) && (width) && (length))
                                                    ? (Number(air) * 1000000000 / (Number(height) * Number(width) * Number(length))).toFixed(1)
                                                    : '-'
                                                }
                                            </Typography>
                                            <Typography variant="subtitle1" >
                                                {((air) && (water))
                                                    ? (Number(air) * 997 / (Number(air) - Number(water))).toFixed(1)
                                                    : '-'
                                                }
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sm={2}></Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <hr style={{ borderTop: '1px solid #95D330' }} />
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={3} sm={3}></Grid>
                                        <Grid item xs={4} sm={4}>
                                            <Typography variant="subtitle1" >Load at Failure(kN): </Typography>
                                            <Typography variant="subtitle1" >Test Machine: </Typography>
                                            <Typography variant="subtitle1" >Type of Fracture: </Typography>
                                            <Typography variant="subtitle1" >Date & time: </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <div>
                                                <input id="load-at-failure"
                                                    value={loadAtFailure}
                                                    // value={reviseTestResult?.loadAtFailure ? reviseTestResult?.loadAtFailure : loadAtFailure}
                                                    // defaultValue={loadAtFailure || reviseTestResult?.loadAtFailure || ""}
                                                    onChange={(e) => setLoadAtFailure(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                /></div>
                                            <div>
                                                <input id="test-machine"
                                                    value={testMachine}
                                                    // value={reviseTestResult?.loadAtFailure ? reviseTestResult?.loadAtFailure : loadAtFailure}
                                                    // defaultValue={loadAtFailure || reviseTestResult?.loadAtFailure || ""}
                                                    onChange={(e) => setTestMachine(e.target.value)}
                                                    style={{ marginTop: '5px', height: '22px', width: '50px' }}
                                                /></div>
                                            <Typography variant="subtitle1" style={{ marginTop: '4px' }}>
                                                {
                                                    (reviseTestResult?.typeOfFailOfSample == "K" || reviseTestResult?.typeofFracture == "K")
                                                        || (reviseTestResult?.typeOfFailOfSample == "SATISFACTORY" || reviseTestResult?.typeofFracture == "SATISFACTORY")
                                                        ? "Satisfactory"
                                                        : "Unsatisfactory"
                                                }
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} >
                                                <DateTimePicker
                                                    value={dayjs(datePickerValue)}
                                                    onChange={(newValue) => setDatePickerValue(newValue ? newValue : null)}
                                                    disableFuture
                                                    timeSteps={{ hours: 1, minutes: 1 }}
                                                    format="DD MMM YYYY hh:mm A"
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} height={15}>
                                        <hr style={{ borderTop: '1px solid #95D330' }} />
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={1} sm={1}></Grid>
                                        <Grid item xs={2} sm={2}>
                                            <GreenButton

                                                variant="contained"
                                                type="submit"
                                                onClick={
                                                    handleSaveButton
                                                }>Save</GreenButton>
                                        </Grid>
                                        <Grid item xs={8} sm={8}></Grid>
                                    </Grid>

                                    <Grid item xs={12} height={10}>
                                        {/* <hr style={{ borderTop: '1px solid #95D330' }} /> */}
                                    </Grid>

                                </Grid>
                                <br></br>
                            </form>
                        }
                    </Box>
                </ListContainer>
            </TestResultContainer>)
    }

    function RemainingContainer() {
        return (
            <FourContainer flexGrow={1}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Heading style={{ marginRight: '20px' }}>Remaining Work 剩餘工作</Heading>
                </div>
                <ListContainer className="data-table-overide-styles">
                    <Box
                        sx={{
                            backgroundColor: '#FFEDED',
                            flexGrow: 1,
                            borderRadius: '20px',
                            border: '1px solid #F09B9B',

                        }}
                    >
                        <StyledTextField
                            defaultValue={''}
                            variant="outlined"
                            size="small"
                            InputProps={{
                                sx: { borderRadius: '20px 1px 1px' },
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#F09B9B' }} />
                                        {/* <label style={{ fontSize: 'xx-small', color: '#F09B9B' }}>RFID / QR / Sample Number / Cube Mark : </label> */}
                                    </InputAdornment>
                                )
                            }}
                            // label="RFID / QR / Sample Number / Cube Mark"
                            // helperText="RFID / QR / Sample Number / Cube Mark"
                            onChange={e => setSearchQuery(e.target.value.toUpperCase())}
                        />
                        {start && (
                            <GreenButton
                                sx={{
                                    float: 'right'
                                }}
                                variant="contained"
                                onClick={() => {
                                    setStart(false);
                                }}
                            >
                                Stop Timer
                            </GreenButton>
                        )}
                        {!start && (
                            <GreenButton
                                sx={{
                                    float: 'right'
                                }}
                                variant="contained"
                                onClick={() => {
                                    setStart(true);
                                }}
                            >
                                Start Timer
                            </GreenButton>
                        )}
                        {isLoading && (
                            <ReactLoading className="justify-items-center" type={"bubbles"} color={'#F09B9B'} height={'20%'} width={'20%'} />
                        )}
                        {!isLoading && tableContent}
                    </Box>
                </ListContainer>

                {/* Countdown */}
                <CountdownContainer
                    startCountdown={startCountdown}
                    secondsLeftOfCountdown={secondsLeftOfCountdown}
                />
            </FourContainer>
        )
    }

    function Overlay() {
        return (
            <OverlayBaseContainer style={showCubeInformationOverlay ? OverlayActiveStyle : {}} onClick={toggleOverlay}>
                <OverlayContentContainer>
                    <OverlayContentHeading>Cube Information 磚資料</OverlayContentHeading>
                    {
                        overlayCubeInformation?.cbtCode ?
                            <OverlayContentListItem> <div>RFID/QR/Sample Number</div> <div>{overlayCubeInformation?.cbtCode}</div></OverlayContentListItem>
                            : <OverlayContentListItem> <div>RFID/QR/Sample Number</div> <div>{`**${overlayCubeInformation?.sampleNumber}**`}</div></OverlayContentListItem>
                    }

                    <OverlayContentListItem> <div>Product:</div> <div>{overlayCubeInformation?.product ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>LRN Name:</div> <div>{overlayCubeInformation?.name ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Cube Mark:</div> <div>{overlayCubeInformation?.cubeMark ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Grade:</div> <div>{overlayCubeInformation?.productGrade ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Concrete Mix ID:</div> <div>{overlayCubeInformation?.cMixId ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Additional Cube Grade:</div> <div>{overlayCubeInformation?.cCubeGradeText ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Supplier:</div> <div>{overlayCubeInformation?.supplier ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Plant:</div> <div>{overlayCubeInformation?.cPlantLocation ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Date of Sampling:</div> <div>{formatDate(overlayCubeInformation?.cSamplingDate as string) ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Date of Cast:</div> <div>{formatDate(overlayCubeInformation?.cDateCast as string) ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Date of Test:</div> <div>{formatDate(overlayCubeInformation?.dateTest as string) ?? '--'}</div></OverlayContentListItem>
                    <OverlayContentListItem> <div>Lab Received Date:</div> <div>{formatDate(overlayCubeInformation?.cReceivedDate as string) ?? '--'}</div></OverlayContentListItem>
                    <OverlayCloseLogo onClick={toggleOverlay}><img src={Main_Close_Logo} alt="close" style={{ width: 'calc(17px + 0.4vw)' }} /> </OverlayCloseLogo>
                    <OverlayCloseLogo onClick={toggleOverlay}><img src={Main_Close_Logo} alt="close" style={{ width: 'calc(17px + 0.4vw)' }} /> </OverlayCloseLogo>
                </OverlayContentContainer>
            </OverlayBaseContainer>
        )
    }

    function EditOverlay() {
        return (

            <OverlayBaseContainer style={showEditInformationOverlay ? OverlayActiveStyle : {}} >
                <OverlayEditContentContainer>
                    {ReviseTestResult()}
                </OverlayEditContentContainer>
            </OverlayBaseContainer>
        )
    }

    return (
        <div>
            {
                <Grid container spacing={1.5}>
                    <Grid item md={12} xs={12}>
                        {RemainingContainer()}
                        {Overlay()}
                        {EditOverlay()}
                    </Grid>
                </Grid>
            }
        </div>
    )
}


export default RemainingWorkContainer; 